/* Omelva · ficha de la braguita (sections/om-producto-faja.liquid) · 1 de 3: selección.
   Al elegir un pack se abre justo debajo de su tarjeta el panel #ompf-panel (solo hay uno: se mueve) con la talla
   y el color de cada prenda («Prenda 1», «Prenda 2»…), el total y los botones. Cada prenda viaja como
   «Unidad N · Talla» / «Unidad N · Color». Pueden ser iguales o distintas; nunca se elige una talla por la clienta.
   Agotados: Shopify solo sabe si un pack está disponible; las tallas, colores o combinaciones sin stock se leen del
   metacampo custom.agotados («6XL, Morado, XL/Beige») y no se pueden elegir.
   Lo comparten om-ficha-carrito.js (añadir y pagar) y om-ficha-extra.js (galería, guía y barra) por window.OMPF. */
(function () {
  var raiz = document.querySelector('[data-ompf]');
  var form = document.getElementById('ompf-form');
  if (!raiz || !form) return;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('ompf-config').textContent); } catch (e) {}
  function t(clave, porDefecto) { return cfg[clave] || porDefecto || ''; }

  var O = window.OMPF = { form: form, t: t, ocupado: false, galeria: null, pintarBarra: function () {}, estado: { color: '' } };
  var campoId = document.getElementById('ompf-variante');
  var radios = [].slice.call(form.querySelectorAll('input[name=ompf-pack]'));
  var panel = document.getElementById('ompf-panel');
  var filas = [].slice.call(form.querySelectorAll('[data-ompf-u]'));
  var cajaCopiar = form.querySelector('[data-ompf-copiar]');
  var nota = form.querySelector('[data-ompf-nota]');
  var errorFilas = form.querySelector('[data-ompf-error=filas]');
  var btnPagar = O.btnPagar = document.getElementById('ompf-pagar');
  var btnAdd = O.btnAdd = document.getElementById('ompf-add');
  var aviso = O.aviso = document.getElementById('ompf-aviso');
  var resumen = document.getElementById('ompf-resumen');
  var clave = 'ompf:' + (cfg.producto || '');

  /* ---------- agotados ---------- */

  function norm(v) { return String(v || '').toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ').trim(); }
  var agotados = String(cfg.agotados || '').split(/[,\n;]/).map(norm).filter(Boolean);
  /* true si la talla, el color o esa pareja talla/color (en cualquier orden) está agotada. */
  function agotado(talla, color) {
    if (!agotados.length) return false;
    var a = norm(talla), b = norm(color);
    return (a && agotados.indexOf(a) >= 0) || (b && agotados.indexOf(b) >= 0) ||
      (a && b && (agotados.indexOf(a + '/' + b) >= 0 || agotados.indexOf(b + '/' + a) >= 0));
  }

  /* ---------- lectura ---------- */

  function packElegido() {
    for (var i = 0; i < radios.length; i++) if (radios[i].checked && !radios[i].disabled) return radios[i];
    return null;
  }
  function unidadesPack() { var r = packElegido(); return r ? parseInt(r.getAttribute('data-n'), 10) || 1 : 0; }
  function sel(fila, cual) { return fila.querySelector('[data-ompf-sel=' + cual + ']'); }
  function filasActivas() { var n = unidadesPack(); return filas.filter(function (f, i) { return i < n; }); }

  /* Propiedades exactas que viajan al carrito, en orden de prenda. */
  function propiedades() {
    var p = {};
    filasActivas().forEach(function (f, i) {
      p['Unidad ' + (i + 1) + ' · Talla'] = sel(f, 'talla').value;
      p['Unidad ' + (i + 1) + ' · Color'] = sel(f, 'color').value;
    });
    return p;
  }

  /* Lo que falta, prenda a prenda. */
  function faltan() {
    var r = { pack: !packElegido(), filas: [] };
    if (r.pack) return r;
    filasActivas().forEach(function (f, i) {
      var vt = sel(f, 'talla').value, vc = sel(f, 'color').value;
      var x = { fila: f, u: i + 1, talla: !vt, color: !vc, agotado: agotado(vt, vc) };
      if (x.talla || x.color || x.agotado) r.filas.push(x);
    });
    return r;
  }
  function completo() { var f = faltan(); return !f.pack && !f.filas.length; }

  /* ---------- pintar ---------- */

  function guardar() {
    try {
      var r = packElegido();
      sessionStorage.setItem(clave, JSON.stringify({
        pack: r ? r.value : '',
        filas: filas.map(function (f) { return [sel(f, 'talla').value, sel(f, 'color').value]; })
      }));
    } catch (e) {}
  }

  /* Marca como agotadas (y desactiva) las opciones sin stock, teniendo en cuenta lo elegido en la otra lista. */
  function marcarAgotados(f) {
    if (!agotados.length) return;
    var st = sel(f, 'talla'), sc = sel(f, 'color');
    [[st, sc, true], [sc, st, false]].forEach(function (par) {
      var otro = par[1].value;
      [].forEach.call(par[0].options, function (op) {
        if (!op.value) return;
        if (op.getAttribute('data-base') === null) op.setAttribute('data-base', op.textContent);
        var no = par[2] ? agotado(op.value, otro) : agotado(otro, op.value);
        op.disabled = no;
        op.textContent = op.getAttribute('data-base') + (no ? ' · ' + t('agotado', 'Agotado') : '');
      });
    });
  }

  function pintarTono(f) {
    var sc = sel(f, 'color'), op = sc.options[sc.selectedIndex], punto = f.querySelector('[data-ompf-tono]');
    if (!punto) return;
    var tono = op && op.value ? op.getAttribute('data-tono') : '';
    punto.hidden = !tono;
    punto.parentNode.classList.toggle('con-tono', !!tono);
    if (tono) punto.style.background = tono;
  }

  function rellenar(txt, n, vt, vc) { return txt.replace('[talla]', vt).replace('[color]', vc).replace('[n]', n); }

  /* Atajo «Usar M · Negro en las 2»: solo si la prenda 1 está completa y alguna otra es distinta. */
  function pintarCopiar() {
    if (!cajaCopiar) return;
    var act = filasActivas(), f1 = act[0];
    var vt = f1 ? sel(f1, 'talla').value : '', vc = f1 ? sel(f1, 'color').value : '';
    var hay = act.length > 1 && vt && vc && !agotado(vt, vc) && act.slice(1).some(function (f) {
      return sel(f, 'talla').value !== vt || sel(f, 'color').value !== vc;
    });
    cajaCopiar.hidden = !hay;
    if (hay) cajaCopiar.querySelector('button').textContent = rellenar(t('copiar', 'Usar [talla] · [color] en las [n]'), act.length, vt, vc);
  }

  function copiar() {
    var act = filasActivas();
    if (act.length < 2) return;
    var vt = sel(act[0], 'talla').value, vc = sel(act[0], 'color').value;
    act.slice(1).forEach(function (f) { sel(f, 'talla').value = vt; sel(f, 'color').value = vc; });
    pintar();
    if (nota) nota.textContent = rellenar(t('copiado', ''), act.length, vt, vc);
    /* El botón desaparece: el foco pasa a la prenda 2, que se puede cambiar. */
    try { sel(act[1], 'talla').focus({ preventScroll: true }); } catch (e) {}
  }

  function pintarResumen() {
    var r = packElegido();
    resumen.textContent = '';
    if (!r) return;
    var linea = document.createElement('strong');
    linea.textContent = t('tuPack', 'Tu pedido:') + ' ' + r.getAttribute('data-nombre') + ' · ' + r.getAttribute('data-precio');
    resumen.appendChild(linea);
  }

  function textoFaltan(f) {
    if (f.pack) return t('faltaPack');
    if (!f.filas.length) return t('listo');
    var n = unidadesPack(), x = f.filas[0];
    if (n === 1 && (x.talla || x.color)) return x.talla && x.color ? t('faltaAmbas') : x.talla ? t('faltaTalla') : t('faltaColor');
    /* Sin nada elegido todavía, una frase corta; después, qué le falta a cada prenda. */
    if (f.filas.length === n && f.filas.every(function (y) { return y.talla && y.color; })) return t('faltaMezcla');
    var partes = [], agot = [];
    f.filas.forEach(function (y) {
      var et = n > 1 ? t('palabra', 'Prenda') + ' ' + y.u : '', q = [];
      if (y.agotado) {
        var vals = [sel(y.fila, 'talla').value, sel(y.fila, 'color').value].filter(Boolean).join(' · ');
        agot.push((et ? et + ': ' : '') + vals + ' — ' + t('agotado', 'Agotado').toLowerCase());
      }
      if (y.talla) q.push(t('phTalla', 'Talla').toLowerCase());
      if (y.color) q.push(t('phColor', 'Color').toLowerCase());
      if (q.length) partes.push(et ? et + ' (' + q.join(' y ') + ')' : q.join(' y '));
    });
    var txt = [];
    if (agot.length) txt.push(agot.join(', ') + '.');
    if (partes.length) txt.push(t('faltaVarias', 'Te falta elegir:') + ' ' + partes.join(', ') + '.');
    return txt.join(' ');
  }

  function pintarAviso() {
    aviso.removeAttribute('data-error');
    aviso.textContent = textoFaltan(faltan());
  }

  function pintarBotones() {
    var r = packElegido();
    if (!O.ocupado) {
      btnPagar.querySelector('[data-ompf-pagar-txt]').textContent = t('pagar', 'Continuar al pago') + (r ? ' · ' + r.getAttribute('data-precio') : '');
      btnAdd.textContent = t('anadir', 'Añadir al carrito');
    }
    O.pintarBarra();
  }

  /* Los errores solo aparecen tras intentar continuar; al corregir, se van solos. */
  function pintarErroresVivos() {
    filas.forEach(function (fl) {
      var vt = sel(fl, 'talla').value, vc = sel(fl, 'color').value, ag = agotado(vt, vc);
      if (vt && !ag) sel(fl, 'talla').classList.remove('falta');
      if (vc && !ag) sel(fl, 'color').classList.remove('falta');
    });
    if (errorFilas && !errorFilas.hidden && !faltan().filas.length) errorFilas.hidden = true;
  }

  function pintar() {
    var r = packElegido(), n = unidadesPack();
    radios.forEach(function (x) {
      var tarjeta = x.closest('.ompf-pack');
      if (tarjeta) tarjeta.classList.toggle('is-on', x.checked);
    });
    if (campoId) campoId.value = r ? r.value : '';
    if (panel) panel.setAttribute('data-n', n);

    /* Solo viajan las prendas del pack elegido; las demás se ocultan y desactivan, pero conservan lo elegido
       por si vuelve a un pack más grande. */
    filas.forEach(function (f, i) {
      var activa = i < n;
      f.hidden = !activa;
      sel(f, 'talla').disabled = !activa;
      sel(f, 'color').disabled = !activa;
      marcarAgotados(f);
      pintarTono(f);
    });
    var f1 = filas[0];
    O.estado.color = f1 ? sel(f1, 'color').value : '';

    pintarCopiar();
    pintarResumen();
    pintarAviso();
    pintarErroresVivos();
    pintarBotones();
    guardar();
  }

  /* ---------- panel bajo el pack ---------- */

  function reducido() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* Lleva el panel debajo de la tarjeta marcada. Si con eso la tarjeta se movería en la pantalla (el panel estaba
     encima), se compensa el scroll para que siga bajo el dedo. */
  function colocarPanel(animar) {
    var r = packElegido(), tarjeta = r ? r.closest('.ompf-pack') : null;
    if (!panel || !tarjeta || tarjeta.nextElementSibling === panel) return;
    var antes = tarjeta.getBoundingClientRect().top;
    tarjeta.parentNode.insertBefore(panel, tarjeta.nextSibling);
    var salto = tarjeta.getBoundingClientRect().top - antes;
    if (Math.abs(salto) > 1) {
      try { window.scrollBy({ top: salto, left: 0, behavior: 'instant' }); } catch (e) { window.scrollBy(0, salto); }
    }
    if (animar && !reducido()) {
      panel.classList.remove('abre');
      void panel.offsetWidth;
      panel.classList.add('abre');
    }
  }

  /* ---------- color → foto ---------- */

  function mostrarColor(valor) {
    var op = filas.length ? [].filter.call(sel(filas[0], 'color').options, function (o) { return o.value === valor; })[0] : null;
    var k = op ? op.getAttribute('data-clave') : '';
    var s = k ? document.querySelector('.ompf-slide[data-color=' + k + ']') : null;
    if (s && O.galeria) O.galeria.irASlide(s, true);
  }

  /* ---------- errores y foco ---------- */

  /* Enseña lo que falta en cada prenda y lleva el foco al primer campo. Devuelve true si no falta nada. */
  function ensenarFaltas() {
    var f = faltan(), primero = null;
    if (f.pack) primero = document.getElementById('elegir-pack');
    f.filas.forEach(function (x) {
      ['talla', 'color'].forEach(function (c) { if (x[c] || x.agotado) sel(x.fila, c).classList.add('falta'); });
      if (!primero) primero = sel(x.fila, x.talla || !x.color ? 'talla' : 'color');
    });
    if (errorFilas) errorFilas.hidden = !f.filas.length;
    pintarAviso();
    if (primero) {
      aviso.setAttribute('data-error', '1');
      var bloque = primero.closest('.ompf-unidad, .ompf-packs') || primero;
      bloque.scrollIntoView({ block: 'center', behavior: reducido() ? 'auto' : 'smooth' });
      try { primero.focus({ preventScroll: true }); } catch (e) { primero.focus(); }
    }
    return !primero;
  }

  /* ---------- eventos ---------- */

  form.addEventListener('change', function (e) {
    var el = e.target;
    if (el.name === 'ompf-pack') {
      if (nota) nota.textContent = '';
      colocarPanel(true);
      pintar();
    } else if (el.hasAttribute && el.hasAttribute('data-ompf-sel')) {
      if (nota) nota.textContent = '';
      if (el.getAttribute('data-ompf-sel') === 'color' && el.value) mostrarColor(el.value);
      pintar();
    }
  });

  form.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ompf-copiar] button') : null;
    if (!b) return;
    e.preventDefault();
    copiar();
  });

  /* ---------- arranque ---------- */

  /* Recupera lo elegido en esta sesión (p. ej. al volver del carrito). Solo valores que existen en las listas. */
  function restaurar() {
    var d = null;
    try { d = JSON.parse(sessionStorage.getItem(clave) || 'null'); } catch (e) {}
    if (!d) return;
    var r = radios.filter(function (x) { return x.value === d.pack && !x.disabled; })[0];
    if (r) radios.forEach(function (x) { x.checked = x === r; });
    if (d.filas) filas.forEach(function (f, i) {
      var v = d.filas[i] || [];
      ['talla', 'color'].forEach(function (c, j) {
        var s = sel(f, c);
        if (v[j] && !s.value && [].some.call(s.options, function (o) { return o.value === v[j]; })) s.value = v[j];
      });
    });
  }

  /* También al volver atrás (el navegador puede haber restaurado los desplegables). */
  function arranque() {
    colocarPanel(false);
    pintar();
    if (O.estado.color) mostrarColor(O.estado.color);
  }

  O.packElegido = packElegido;
  O.propiedades = propiedades;
  O.completo = completo;
  O.ensenarFaltas = ensenarFaltas;
  O.pintarAviso = pintarAviso;
  O.pintarBotones = pintarBotones;
  O.mostrarColor = mostrarColor;
  O.reducido = reducido;
  O.arranque = arranque;

  restaurar();
  arranque();
})();